import React, { FC } from 'react';
import { graphql } from 'gatsby';

import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import H5 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H5';
import Download from '@bitcoin-portal/bitcoincom-pkg-components/dist/Download';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';

import { Header, Apps, Content, StyledCard } from './styled';
import Image from '../../../components/Image';

import imageSrc from '../../../assets/homepage-app.png';

const Wallet: FC<Queries.SeoWalletFragment> = ({ wallet }) => {
  const { ios, android } = wallet || {};

  return (
    <Section>
      <ContentBlock>
        <StyledCard padded direction="row">
          <Image
            image={imageSrc}
            alt="Take control of your finances"
            objectFit="contain"
            width="350px"
            style={{
              filter: 'drop-shadow(0px 10px 20px rgba(39, 147, 255, 0.6))',
              textAlign: 'center',
            }}
          />

          <Content>
            <Header>
              <H5>Download the Bitcoin.com app today</H5>
            </Header>
            <Apps>
              <Download
                width="200px"
                type={Download.Types.AppStore}
                link={ios || ''}
              />
              <Download
                width="200px"
                type={Download.Types.PlayStore}
                link={android || ''}
              />
            </Apps>
          </Content>
        </StyledCard>
      </ContentBlock>
    </Section>
  );
};

export const query = graphql`
  fragment SeoWallet on Json {
    wallet {
      title
      description
      wallets
      ios
      android
      image {
        childImageSharp {
          gatsbyImageData(width: 350, placeholder: NONE, quality: 100)
        }
      }
    }
  }
`;

export default Wallet;
